import React from "react";

import { Card, Table } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";


const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

export const ReceiptDetails = ({data}) => {
    
  return (
    <Card className="pt-5 pl-5 bg-light">
      <h5> 
        <SVG
            src={toAbsoluteUrl("/media/svg/client/logo-light.svg")}
            style={{ width: "30px", height: "30px" }}
        /> {" "} 
        Receipt No. <b>{data.latestAudit.rcpt_number}</b> Details
      </h5>
      <Table variant="dark">
        <tbody>
          <tr>
            <td> <b>Receipt No. </b>: </td>
            <td> { data.latestAudit.rcpt_number } </td>
            <td> <b>Customer</b>: </td>
            <td> { data.latestAudit.cust_first_name + " " + data.latestAudit.cust_last_name} </td>
            <td> <b>Service</b>: </td>
            <td> { data.latestAudit.service_item_desc } </td>
          </tr>
          <tr>
            <td> <b>Province</b>: </td>
            <td> { data.latestAudit.province_name } </td>
            <td> <b>Department</b>: </td>
            <td> { data.latestAudit.dept_name } </td>
            <td> <b>Current Status</b>: </td>
            <td> { data.latestAudit.rcpt_status_desc } on {format(parseISO(data.latestAudit.audit_datetime),"dd-MM-yyyy")} at { format(parseISO(data.latestAudit.audit_datetime),"HH:mm a") } </td>
          </tr>
          <tr>
            <td> <b>Status logs</b>: </td>
            <td>
              {data.oldAuditList.length > 0 ? 
                data.oldAuditList.map((r, idx) => (
                  <span key={idx}>
                    {r.rcpt_status_desc} - {format(parseISO(r.audit_datetime),"dd-MM-yyyy")} at {format(parseISO(r.audit_datetime),"HH:mm a")} <br/>
                  </span>
                ))
                : "No logs to display."
              }
            </td>
            <td> <b>Total Amount</b>: </td>
            <td> { moneyFormater.format(data.latestAudit.total_amnt) } </td>
            {/* <td> <b>Group</b>: </td>
            <td> { data.latestAudit.group } </td> */}
          </tr>
        </tbody>
      </Table>
    </Card>
  )
};